<template>
    <el-cascader-panel ref="cascader" v-model="cascaderSelect" v-loading="cascaderLoading" :options="cascaderData" @expand-change="handleExpandChange" @change="handleChange">
        <template slot-scope="{ node, data: row }">
            <slot :row="row" :node="node">
                <span v-if="row.text.length < maxWord" class="cascader_text">{{ row.text }}</span>
                <el-popover v-else trigger="hover" placement="right">
                    <span>{{ row.text }}</span>
                    <span slot="reference" class="cascader_text">{{ row.text }}</span>
                </el-popover>
            </slot>
            <slot name="badge" :row="row" :node="node">
                <el-badge v-show="row.itemNumber" :value="Number(row.itemNumber)" :max="99" class="badge"></el-badge>
            </slot>
        </template>
    </el-cascader-panel>
</template>
<script>
import { toFixedRe, debounce } from '@/assets/js/common.js'
import customColumns from '@/components/common/customColumns.vue'
export default {
    props: {
        productParams: Object,
        maxWord: {
            type: Number,
            default: 7
        },
        billType: {
            type: String,
            default: 'XSD'
        },
        getDataWhenCreate: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            brandArgs: {
                url: '/Account/dataSearchVue/selectFirstType.html',
                billType: this.billType
            },
            brandTypeArgs: {
                url: '/Account/dataSearchVue/selectSecondType.html',
                firstId: '',
                type: '',
                billType: this.billType
            },
            productArgs: this.productParams,
            cascaderLoading: false,
            cascaderSelect: ['', ''],
            cascaderData: []
        }
    },
    created() {
        if (this.getDataWhenCreate) {
            this.getBrandData()
        }
    },
    watch: {
        productParams(val) {
            console.log(val, 123123)
            this.productArgs = val
            // this.getBrandData()
        }
    },
    methods: {
        async getBrandData() {
            this.cascaderLoading = true
            const { data: res } = await this.$http.post(this.brandArgs.url, this.Qs.stringify({ ...this.brandArgs, ...{ customerID: this.productArgs.customerID, orderMeetID: this.productArgs.orderMeetID } }))
            this.cascaderLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            let isGetBrandTypeData = false
            this.cascaderData = JSON.parse(res.result.data).map((item, index, arr) => {
                if (this.cascaderSelect[0]) {
                    if (!isGetBrandTypeData) {
                        this.getBrandTypeData(arr.filter(element => element.value == this.cascaderSelect[0])[0])
                        isGetBrandTypeData = true
                    }
                } else {
                    if (index == 0) {
                        this.brandTypeArgs.firstId = this.productArgs.firstValue = this.cascaderSelect[0] = item.value
                        this.brandTypeArgs.type = this.productArgs.firstType = item.type
                        this.getBrandTypeData(item)
                    }
                }
                item['children'] = [{ text: '全部', value: '', type: '', itemNumber: 0 }]
                return item
            })
        },
        async getBrandTypeData(row) {
            this.cascaderLoading = true
            let _obj = {
                customerID: this.productArgs.customerID
            }
            if (this.billType == 'DBD') {
                _obj.inWarehouseID = this.productArgs.inWarehouseID
            } else {
                orderMeetID: this.productArgs.orderMeetID
            }
            const { data: res } = await this.$http.post(this.brandTypeArgs.url, this.Qs.stringify({ ...this.brandTypeArgs, ..._obj }))
            this.cascaderLoading = false
            if (res.code != 'success') return false
            res.result = JSON.parse(res.result)
            row.children = res.result.total ? [...[{ text: '全部', value: '', type: '', itemNumber: 0 }], ...JSON.parse(res.result.data)] : []
        },
        handleExpandChange() {
            let activePath = this.$refs['cascader'].activePath[0].data
            this.brandTypeArgs.firstId = this.productArgs.firstValue = this.cascaderSelect[0] = activePath.value
            this.cascaderSelect[1] = ''
            this.brandTypeArgs.type = this.productArgs.firstType = activePath.type
            this.getBrandTypeData(activePath)
            this.productArgs.page = 1
            this.productArgs.secondValue = ''
            this.productArgs.secondType = ''
            this.$emit('get-product-data', this.productArgs)
        },
        handleChange(value) {
            let activePath = this.$refs['cascader'].getCheckedNodes()[0].data
            this.cascaderSelect = value
            this.productArgs.page = 1
            this.productArgs.secondValue = activePath.value
            this.productArgs.secondType = activePath.type
            this.$emit('get-product-data', this.productArgs)
        }
    }
}
</script>
<style scoped lang="less">
/deep/.el-cascader-menu{
    color: #333;
}
</style>